
import React, { useState } from 'react'

export const KidAgeCmp = ({ addKidage }) => {
  const [kidage, setKidage] = useState('')

  function onChangeInput(event) {
    setKidage(event.target.value)
  }

  function handlerContinuar(kidage) {
    addKidage(kidage)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerContinuar(event.target.value);
    }
  };

  // useEffect(() => {
  //     console.log('Respuestas actualizadas:', respuestas);
  // }, [respuestas]);

  return (
    <div style={{ marginTop: '-60%'}}>
      <h1 className="text-2xl font-bold mb-10">Qué edad tiene?</h1>
      <div className="flex flex-col items-center">
        <input onKeyDown={handleKeyPress} type="text" className="input input-bordered input-lg w-full max-w-xs" placeholder="Escribe aquí tu respuesta..." value={kidage} onChange={onChangeInput} />
        <button disabled={kidage ? false : true} className="btn btn-primary mt-5" onClick={() => handlerContinuar(kidage)}>Continuar</button>
      </div>
    </div>
  )
}